// Exchange — discovery tabs. Pure presentation; counts come from
// `countByTab` in exchange-derive.ts and are passed in.

import type { DiscoveryTabId } from "./exchange-derive.ts";

interface Tab {
  id: DiscoveryTabId;
  label: string;
  count: number;
}

interface Props {
  active: DiscoveryTabId;
  onChange: (id: DiscoveryTabId) => void;
  counts: Record<DiscoveryTabId, number>;
}

export function ExchangeDiscoveryTabs({ active, onChange, counts }: Props): JSX.Element {
  const tabs: readonly Tab[] = [
    { id: "all", label: "All signals", count: counts.all },
    { id: "trending", label: "Trending", count: counts.trending },
    { id: "high-edge", label: "High edge", count: counts["high-edge"] },
    { id: "ending", label: "Ending soon", count: counts.ending },
    { id: "watch", label: "Watchlist", count: counts.watch },
    { id: "disagree", label: "Agent disagreement", count: counts.disagree },
  ];
  return (
    <div
      className="ex-tabs"
      style={{
        marginLeft: 0,
        marginBottom: 12,
        borderBottom: "1px solid var(--border-faint)",
        paddingBottom: 4,
      }}
    >
      {tabs.map((t) => (
        <button
          key={t.id}
          className={`ex-tab ${active === t.id ? "active" : ""}`}
          onClick={() => onChange(t.id)}
          type="button"
        >
          {t.label}
          <span className="count">{t.count}</span>
        </button>
      ))}
    </div>
  );
}
